module.exports = __webpack_public_path__ + "static/media/saudinetlink.8867a10c.webp";